/**
 * Sidebar Utility Functions
 * Helper functions for sidebar logic
 */

import { K_PAGE_WITH_SIDEBAR } from "./sidebarMenu.config";

/**
 * Check if sidebar should be shown for current route
 * @param {Object} location - React Router location object
 * @param {boolean} authenticated - User authentication status
 * @returns {boolean}
 */
export const shouldShowSidebar = (location, authenticated) => {
  if (!location || !location.pathname) {
    return false;
  }

  // Jika tidak authenticated, jangan tampilkan sidebar
  if (!authenticated) {
    return false;
  }

  const pathParts = location.pathname.split("/").filter(Boolean);
  const firstPath = pathParts[0] || "";
  return K_PAGE_WITH_SIDEBAR.includes(firstPath);
};

/**
 * Check if a path is active
 * @param {string} path - Path to check
 * @param {string} currentPath - Current location pathname
 * @param {boolean} exact - Whether to match exactly
 * @returns {boolean}
 */
export const isActive = (path, currentPath, exact = false) => {
  if (exact) {
    return currentPath === path;
  }
  return currentPath.startsWith(path);
};

/**
 * Check if any submenu item is active
 * @param {Array} submenuItems - Array of submenu items
 * @param {string} currentPath - Current location pathname
 * @returns {boolean}
 */
export const isSubmenuActive = (submenuItems, currentPath) => {
  return submenuItems.some((subItem) => currentPath.startsWith(subItem.path));
};

/**
 * Get expanded menus based on active submenus
 * @param {Array} menuItems - Array of menu groups (each group has items array)
 * @param {string} currentPath - Current location pathname
 * @returns {Object} Object with menu paths as keys and boolean values
 */
export const getInitialExpandedMenus = (menuItems, currentPath) => {
  const expandedMenus = {};

  menuItems.forEach((group) => {
    if (group.items) {
      group.items.forEach((item) => {
        if (item.hasSubmenu && item.submenu) {
          const submenuActive = isSubmenuActive(item.submenu, currentPath);
          if (submenuActive) {
            expandedMenus[item.path] = true;
          }
        }
      });
    }
  });

  return expandedMenus;
};

/**
 * Update main content margin based on sidebar state
 * @param {boolean} shouldShow - Whether sidebar should be shown
 * @param {boolean} isMobile - Whether in mobile view
 * @param {boolean} isCollapsed - Whether sidebar is collapsed
 */
export const updateMainContentMargin = (
  shouldShow,
  isMobile,
  isCollapsed,
  forceHide = null
) => {
  const mainContent = document.getElementById("main-content-wrapper");
  if (!mainContent) return;

  const shouldShowSidebar =
    forceHide === null ? shouldShow : !forceHide;

  if (shouldShowSidebar && !isMobile) {
    mainContent.style.marginLeft = isCollapsed ? "72px" : "240px";
    mainContent.style.transition = "margin-left 0.2s ease";
  } else {
    mainContent.style.marginLeft = "0";
    mainContent.style.transition = "margin-left 0.2s ease";
  }
};

